import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, IconButton, Button, Grid, Divider } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { closelightbox } from "../../util/Functions";
import { Close, FileCopyOutlined } from "@mui/icons-material";
import { theme, customStyles2 } from "../../util/TableStyles";
import { noDataComponent } from "../../util/DataObject";
import { ThemeProvider } from "@mui/material/styles";

const VerifyInfo = (props) => {
    const [data, setData] = useState([]);
    const copy = (data) => {
        navigator.clipboard.writeText(data);
    };
    const init = () => {
        let ine = ["curp", "gname", "lname", "slname", "bdate"];
        let passport = ["name", "lastName", "bdate"];
        let info = [];

        (props.contentModal.typeIdentity === "INE" ? ine : passport).map(item => {
            return info.push({
                customer: props.contentModal[`${item}Customer`],
                service: props.contentModal[`${item}Service`],
                validate: props.contentModal[`${item}Validate`],
            })
        })

        setData(info);
    };

    const columns = [
        { selector: (row) => row.customer, name: "Datos cliente", sortable: true, width: "38%" },
        { cell: (row) => <>{row.service} <FileCopyOutlined titleAccess={`Copiar`} fontSize='small' sx={{ml: 1}} color='primary' onClick={copy.bind(this, row.service)} cursor={'pointer'} /></>, name: "Datos validación", sortable: true, width: "42%" },
        { cell: (row) => row.validate ? <Typography color={theme.palette.success.main}>Correcto</Typography> : <Typography color={theme.palette.warning.main}>Incorrecto</Typography>, name: "Validación", sortable: true, width: "20%" }
    ];

    useEffect(() => {
        props.contentModal && init();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Dialog open={true} sx={{"& .MuiDialog-container": {"& .MuiPaper-root": {maxWidth: "700px"}}}} fullWidth>
            <ModalStyle property={String(false)}>
                <DialogTitle>
                    {`Verificación de ${props.contentModal.typeIdentity}`}
                    <IconButton id="headButton" onClick={closelightbox}>
                        <Close />
                    </IconButton>
                </DialogTitle>

                <DialogContent sx={{ pb: 0 }}>
                    <Divider />
                    <Grid display={"flex"} my={2}>
                        <Typography fontWeight={"bold"} mr={1}>Resultado:</Typography>
                        <Typography fontWeight={"bold"} color={props.contentModal.validate ? theme.palette.success.main : theme.palette.warning.main}>
                            Documento {`${props.contentModal.validate ? "Legible" : "Ilegible" }`}
                        </Typography>
                    </Grid>
                    <div style={{ width: "100%", margin: "auto" }}>
                        <ThemeProvider theme={theme}>
                            <DataTable
                                columns={columns}
                                data={data}
                                customStyles={customStyles2}
                                noDataComponent={noDataComponent}
                            />
                        </ThemeProvider>
                    </div>
                </DialogContent>

                <DialogActions>
                    <Button variant="contained" onClick={closelightbox}>
                        Aceptar
                    </Button>
                </DialogActions>
            </ModalStyle>
        </Dialog>
    );
};

export default VerifyInfo;
